<template>
    <th @click="changeOrder()" :class="[activeClass,directionClass]">
        <slot></slot>
        <span class="direction"></span>
    </th>
</template>

<script>
export default {
    props: ["order", "direction", "orderKey"],
    data() {
        return {};
    },
    methods: {
        changeOrder() {
            if (this.isActive) {
                this.$emit(
                    "update:direction",
                    this.direction == "asc" ? "desc" : "asc"
                );
            } else {
                this.$emit("update:order", this.orderKey);
                this.$emit("update:direction", "asc");
            }
        }
    },
    computed: {
        isActive() {
            return this.order == this.orderKey;
        },
        activeClass() {
            return this.isActive ? "th-active" : "";
        },
        directionClass() {
            if (this.isActive && this.direction == "desc") {
                return "th-order-desc";
            }
            return "th-order-asc";
        }
    }
};
</script>

<style lang="scss" scoped>
th {
    position: relative;
    vertical-align: middle;
    cursor: pointer;

    $primary-color: #727cf5;
    .direction {
        display: inline-block;
        // content: "";
        position: relative;
        border: 0;
        margin-bottom: 2.5px;
        width: 10px;
        height: 10px;

        &:before {
            position: absolute;
            content: "";
            border: 4px solid #000000;
            border-left-color: transparent;
            border-right-color: transparent;
            border-top-color: transparent;
            width: 8px;
            height: 8px;
            top: -2px;
        }

        &:after {
            position: absolute;
            content: "";
            border: 4px solid #000000;
            border-left-color: transparent;
            border-right-color: transparent;
            border-bottom-color: transparent;
            width: 8px;
            height: 8px;
            top: 8px;
        }
    }
    &.th-active {
        color: $primary-color;

        .direction {
            border: 5px solid $primary-color;
            border-left-color: transparent;
            border-right-color: transparent;

            &:before,
            &:after {
                display: none;
            }
        }

        &.th-order-asc .direction {
            border-top-color: transparent;
        }

        &.th-order-desc .direction {
            border-bottom-color: transparent;
            // margin-bottom: 0;
            margin-bottom: -2.5px;
        }
    }
}
</style>
